import './App.css';
import Navbar from '../Navbar/Navbar';
import Home from '../Home/Home';
import About from '../About/About';
import Projects from '../Projects/Projects';
import Contact from '../Contact/Contact';
import Join from '../Join/Join';


function App() {
  return (
    <div className="App">
      <div className='appus' >
      <Navbar/>
      <Home/>
      </div>
      <About/>
      <Projects/>
      <Contact/>
      <Join/>
    </div>
  );
}

export default App;
